<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>&nbsp;&nbsp;&nbsp; {{ Item }}</h2>
    </div>
</div>

<div class="card card-w-title col-12 border-round Arc">
    <form [formGroup]="apptform" (ngSubmit)="refresh()">
        <div class="p-fluid grid">
            <div class="field col-12 md:col-6 lg:col-6 xl:col-3 pb-0 mb-0">
                <p-panel header="Select Appointment Type:" class="pb-0">
                    <span class="r-1">
                        <p-selectButton [options]="stateOptions"
                                        formControlName="isResource"
                                        optionLabel="label"
                                        optionValue="value"
                                        (onChange)="setSelection($event)"></p-selectButton>
                    </span>
                </p-panel>
            </div>
            <div class="field col-12 md:col-6 lg:col-6 xl:col-3 pb-0 mb-0"
                 *ngIf="isprovider == true">
                <span>
                    <p-panel header="Select Provider:">
                        <p-dropdown *ngIf="providerList"
                                    dataKey="providerId"
                                    [options]="providerList"
                                    formControlName="provider"
                                    optionLabel="providerName"
                                    [showClear]="true"
                                    placeholder="Select a Provider"
                                    class="w-full"
                                    (onChange)="setproviderId()"></p-dropdown>
                    </p-panel>
                </span>
            </div>
            <div class="field col-12 md:col-6 lg:col-6 xl:col-3 pb-0 mb-0"
                 *ngIf="isprovider == false">

                <span>
                    <p-panel header="Select Resource:">
                        <!--<p-dropdown *ngIf="ResourceList" dataKey="resourceId" [options]="ResourceList" formControlName="resource" (onChange)="setproviderId()"
                                    optionLabel="resourceName" placeholder="-Select-" class="p-fluid"></p-dropdown>-->

                        <p-dropdown *ngIf="ResourceList"
                                    dataKey="resourceId"
                                    [options]="ResourceList"
                                    formControlName="resource"
                                    optionLabel="resourceName"
                                    [showClear]="true"
                                    placeholder="Select a Resource"
                                    class="w-full"
                                    (onChange)="setproviderId()"></p-dropdown>
                    </p-panel>
                </span>
            </div>
            <div class="field col-12 md:col-6 lg:col-6 xl:col-3 pr-0 pb-0 mb-0">
                <span class="p-float-label pt-1">
                    <p-panel header="Appointment Date:">
                        <p-calendar formControlName="apptDate"
                                    [readonlyInput]="true"
                                    showButtonBar="true"
                                    [showIcon]="true"
                                    styleClass="myWid70"
                                    (onSelect)="OnSelectAppointmentDateChange($event)"
                                    class="text-color"></p-calendar>
                    </p-panel>
                </span>
            </div>

            <div class="field md:col-0.5 pl-0" style="align-self: self-end">
                <p-button type="submit"
                          label="Clear"
                          severity="secondary"
                          icon="pi pi-refresh"></p-button>
            </div>
            <div class="field md:col-0.5 pl-2"
                 style="align-self: self-end"
                 *ngIf="setPrintFlag">
                <button pButton
                        type="button"
                        icon="pi pi-print"
                        label="Print"
                        class="p-button-plain"
                        (click)="printAppointments()"
                        title="Print Appointments"></button>
            </div>
        </div>
    </form>
</div>

<!--<p-table #table *ngIf="appointments" [resetPageOnSort]="false" lazy="true" [lazyLoadOnInit]="false" (onLazyLoad)="nextPage($event);" [totalRecords]="appointments.totalRecords" [currentPageReportTemplate]="'{currentPage} of {totalPages}'" [columns]="cols" [alwaysShowPaginator]="false" [rows]="rows"
         [paginator]="Showrecords" [value]="appointments.data" selectionMode="single" [autoLayout]="true"
         [(selection)]="selectedPatient" [responsive]="true">-->
<!--<ng-template pTemplate="caption">
    <div style="display: flex; justify-content: space-between; align-items: center;">
        <div>List</div>


    </div>
</ng-template>-->
<!--<ng-template pTemplate="header" let-columns *ngIf="Showrecords==true">
    <tr>
        <th></th>
        <th *ngFor="let col of columns" [hidden]="col.hidden" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                        ariaLabelDesc="Activate to sort in descending order"
                        ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>


    </tr>
</ng-template>
<ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr [pSelectableRow]="rowData">
        <td>
            <button pButton type="button" icon="pi pi-user" class="ui-button-success" [rounded]="true"  [ngStyle]="{'background-color': '#142066','color':'white'}" style="font-size: 0.7em;" (click)="getPatientDetails(rowData['patientId'],rowData['patientName'])"></button>
        </td>

        <td *ngFor="let col of columns" [hidden]="col.hidden">
            de-->
<!--<span class="column-title">{{col.header}}</span>-->
<!--{{rowData[col.field]}}
            </td>

        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <div class="w-12 bg-white">
            <div class="" style="text-align: center;">
                <img _ngcontent-ng-c683320295="" class="profile-image" style="border-radius: 50%; width: 10rem; padding-top: 1rem; " src="assets/imagesNew/table_error.png">
            </div>
            <hr style="margin-bottom: 0.5rem;" />
            <div class="" style="text-align: center; font-size: larger; color: #1d428F; ">
                <i>No Records found.</i>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="paginatorleft" let-state>
        Showing {{(state.page  * state.rows) + 1}} to {{state.rows * (state.page + 1)}} of {{state.totalRecords}} entries.
    </ng-template>
</p-table>-->

<p-table *ngIf="appointments"
         [responsive]="true"
         [columns]="cols"
         [value]="appointments.data"
         selectionMode="single"
         dataKey="appointmentId"
         [resetPageOnSort]="true"
         [lazy]="false"
         [rows]="rows"
         [paginator]="true"
         [showRecords]="true"
         (sortFunction)="customSort($event, 1)"
         [customSort]="true">
    <ng-template pTemplate="caption"></ng-template>

    <ng-template pTemplate="header" let-columns>
        <tr>
            <th style="border: 1px solid #808080; text-align: left"></th>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                {{ col.header }}
                <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body"
                 let-rowData
                 let-columns="columns"
                 let-i="rowIndex">
        <tr [pSelectableRow]="rowData" (click)="getPatientDetails(rowData)">
            <td style="
          text-align: left;
          border: 1px solid #808080;
          padding: 0.5% 0% 0.5% 0%;
        ">
                <p-button icon="pi pi-user"
                          [rounded]="true"
                          severity="info"
                          (click)="getPatientDetails(rowData)" />
            </td>
            <!--<td *ngFor="let col of columns">
        <ng-container *ngIf="col.field !== 'isResolved'; else ptflag">
            {{ rowData[col.field] }}
        </ng-container>
        <ng-template #ptflag>
            <ng-container *ngIf="rowData['isResolved'] && col.field === 'isResolved'; else ptflagNo">
                Yes
            </ng-container>
            <ng-template #ptflagNo> No </ng-template>
        </ng-template>
    </td>-->

            <td *ngFor="let col of columns">
                <ng-container *ngIf="col.field !== 'isResolved'; else ptflag">
                    <ng-container *ngIf="col.field === 'appointmentTime'; else defaultCell">
                        {{ rowData[col.field] | time12Hour }}
                    </ng-container>
                    <ng-template #defaultCell>
                        {{ rowData[col.field] }}
                    </ng-template>
                </ng-container>
                <ng-template #ptflag>
                    <ng-container *ngIf="rowData['isResolved']; else ptflagNo">Yes</ng-container>
                    <ng-template #ptflagNo>No</ng-template>
                </ng-template>
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <div class="w-12 bg-white">
            <div style="text-align: center">
                <img class="profile-image"
                     style="border-radius: 50%; width: 10rem; padding-top: 1rem"
                     src="assets/imagesNew/table_error.png" />
            </div>
            <hr style="margin-bottom: 0.5rem" />
            <div style="text-align: center; font-size: larger; color: #1d428f">
                <i>No records found</i>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="paginatorleft" let-state>
        <span *ngIf="state.totalRecords > pageSize">
            Showing {{ state.page * state.rows + 1 }} to
            {{ state.rows * (state.page + 1) }} of {{ state.totalRecords }} records.
        </span>
    </ng-template>
</p-table>

<!-- Print functionality  for Appointments List -->
<div class="panel table-responsive"
     id="PrintAppointments_List"
     style="display: none">
    <div *ngIf="!isprovider"
         style="
      display: flex;
      background-color: #ffffff;
      margin-bottom: 1.5%;
      padding: 0.5%;
    ">
        <div style="
        display: flex;
        justify-content: left;
        align-items: center;
        width: 50%;
      ">
            <span>Resource:&nbsp;</span>
            <span><strong>{{ providerName }}</strong></span>
        </div>
        <div style="
        display: flex;
        justify-content: right;
        align-items: center;
        width: 50%;
      ">
            <span>Appointment Date:&nbsp;</span>
            <span><strong>{{ appDateStringPrint }}</strong></span>
        </div>
    </div>
    <div *ngIf="isprovider"
         style="
      display: flex;
      background-color: #ffffff;
      margin-bottom: 1.5%;
      padding: 0.5%;
    ">
        <div style="
        display: flex;
        justify-content: left;
        align-items: center;
        width: 50%;
      ">
            <span>Provider:&nbsp;</span>
            <span><strong>{{ providerName }}</strong></span>
        </div>
        <div style="
        display: flex;
        justify-content: right;
        align-items: center;
        width: 50%;
      ">
            <span>Appointment Date:&nbsp;</span>
            <span><strong>{{ appDateStringPrint }}</strong></span>
        </div>
    </div>
    <div style="
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0% 0% 0% 0%;
    ">
        <table style="width: 100%; border-collapse: collapse; border: 1px solid grey"
               id="appointment_print_table_tbody">
            <thead style="
          background-color: #142066;
          border: 0px solid #808080;
          color: snow;
        ">
                <tr>
                    <th style="border: 1px solid #808080; text-align: left">Time</th>
                    <th style="border: 1px solid #808080; text-align: left">
                        Patient Name
                    </th>
                    <th style="border: 1px solid #808080; text-align: left">Subject</th>
                    <th style="border: 1px solid #808080; text-align: left">Reason</th>
                    <th style="border: 1px solid #808080; text-align: left">Status</th>
                </tr>
            </thead>
            <tbody id="appointment_print_table_tbody">
                <tr *ngFor="let item of appointmentsPrint?.data"
                    style="border: 1px solid #808080">
                    <td style="
              text-align: left;
              border: 1px solid #808080;
              padding: 0.5% 0% 0.5% 0%;
            ">
                        {{ item.appointmentTime | time12Hour }}
                    </td>
                    <td style="
              text-align: left;
              border: 1px solid #808080;
              padding: 0.5% 0% 0.5% 0%;
            ">
                        {{ item.patientName }}
                    </td>
                    <td style="
              text-align: left;
              border: 1px solid #808080;
              padding: 0.5% 0% 0.5% 0%;
            ">
                        {{ item.appointmentSubject }}
                    </td>
                    <td style="
              text-align: left;
              border: 1px solid #808080;
              padding: 0.5% 0% 0.5% 0%;
            ">
                        {{ item.appointmentReason }}
                    </td>
                    <td style="
              text-align: left;
              border: 1px solid #808080;
              padding: 0.5% 0% 0.5% 0%;
            ">
                        {{ item.appointmentStatus }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="appointments?.data.length == 0"
         class="alert alert-warning"
         role="alert"
         style="text-align: center">
        <span class="glyphicon glyphicon-exclamation-sign"
              aria-hidden="true"></span>
        <span class="sr-only">Error:</span>
        <i>No records found</i>
    </div>
</div>



<!-- Password Expire Popup message-->

<p-dialog [(visible)]="isViewedMessage" [draggable]="false" [modal]="true"  [style]="{ width: '90%', maxWidth: '400px' }" (onHide)="onDialogClose()">
    <p-header>
        Password Expire
    </p-header>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12 text-center">
                <span class="d-flex justify-content-center align-items-center">
                    <img src="/../../../assets/imagesNew/password_warning.png"
                         alt="Warning Icon"
                         class="img-fluid"
                         style="max-width: 200px; height: auto;" />
                </span>
            </div>
            <h5 class="col-12 text-center mt-3 mb-0">
                {{pNearExpirMessage}}
            </h5>
        </div>

        <!-- Buttons Section with Spacing -->
        <div class="row justify-content-center mt-3">
            <div class="col-12 d-flex justify-content-between gap-4">
                <button pButton type="submit" label="Change Password" icon="pi pi-save"  (click)="goToChangePassword()"
                        class="p-button-plain flex-grow-1 px-4"></button> &nbsp;
                <button pButton type="button" icon="pi pi-times-circle" label="Continue"
                        class="ui-button-secondary flex-grow-1 px-4" (click)="ackOK()"></button>
            </div>
        </div>
    </div>
</p-dialog>
